import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { LateFeeConfigType } from '../../../types/Finance';

const initialState:LateFeeConfigType = {
  feeAmount: 0,
  feePercentage: 0,
  daysAfterDueDate: 0,
  idPaymentType: '',
  startDay: 0,
  endDay: 0
}

const lateFeeConfigSlice = createSlice({
  name: "lateFeeConfig",
  initialState,
  reducers: {
    setLateFeeConfigData:(state, action:PayloadAction<LateFeeConfigType>)=>({...state, ...action.payload}), 
    resetLateFeeConfigData :()=>({...initialState})
  }
});

export const {setLateFeeConfigData,resetLateFeeConfigData} = lateFeeConfigSlice.actions

export default lateFeeConfigSlice.reducer